interface CloseButtonProps {
  onClick: () => void;
  className?: string;
  ariaLabel?: string;
}

export const CloseButton = ({
  onClick,
  className = '',
  ariaLabel = 'Close',
}: CloseButtonProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`shrink-0 size-12 inline-flex justify-center items-center gap-x-2 rounded-full border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 focus:outline-none focus:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none ${className}`}
    >
      <span className="sr-only">{ariaLabel}</span>
      <svg
        className="shrink-0 size-6"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M18 6 6 18"></path>
        <path d="m6 6 12 12"></path>
      </svg>
    </button>
  );
};
